module.exports = __webpack_public_path__ + "static/media/mi-liga.939507d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/mi-liga.png
// module id = 336
// module chunks = 0